import { render, staticRenderFns } from "./UsersSeatingStatus.vue?vue&type=template&id=0a6428f0&"
import script from "./UsersSeatingStatus.vue?vue&type=script&lang=js&"
export * from "./UsersSeatingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports